import { render } from "./CreateGif.vue?vue&type=template&id=4a85fa36"
import script from "./CreateGif.vue?vue&type=script&lang=js"
export * from "./CreateGif.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__